<template>
  <div>
    <div>
      <table class="table-auto w-full">
        <thead>
        <tr class="text-left border-b font-semibold">
          <td class="px-4 py-2">Access points</td>
          <td class="px-4 py-2">Start date</td>
          <td class="px-4 py-2">End date</td>
          <td class="px-4 py-2">Rules</td>
          <td class="px-4 py-2"></td>
        </tr>
        </thead>
        <tbody>
        <tr class="border-b hover:bg-gray-200" v-for="option in settings" :key="option.id">
          <td class="px-4 py-2">
            <router-link class="mr-2 hover:text-teal-500"
                         :to="{name: 'access_point', params: {apId: ap.id}}"
                         v-for="ap in option.access_points" :key="ap.id">{{ ap.name }}
            </router-link>
          </td>
          <td class="px-4 py-2">{{ option.start_date }}</td>
          <td class="px-4 py-2">{{ option.end_date }}</td>
          <td class="px-4 py-2">{{ option.factor + " " + option.factor_count + " " + option.factor_type }}</td>
          <td class="px-4 py-2"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-4">

      <label class="block text-sm">Networks</label>
      <multiselect v-model="venues" placeholder="Search networks" :options="filters.venues" :multiple="true"
                   track-by="id" label="name" :taggable="true"></multiselect>

      <label class="block text-sm mt-4 ">Access points</label>
      <multiselect v-model="access_points" placeholder="Search access point" :options="filters.aps"
                   :multiple="true"
                   track-by="id"
                   label="name"
                   :taggable="true"></multiselect>


      <div class="my-3 flex justify-between">
        <div class="w-full mr-2">
          <label class="block text-sm mt-4 "> Display from</label>
          <date-picker v-model="params.start_date" valueType="format"></date-picker>
        </div>
        <div class="w-full ml-2">
          <label class="block text-sm mt-4 "> Up to</label>
          <date-picker class="" v-model="params.end_date" valueType="format"></date-picker>
        </div>
      </div>
      <div class="block my-3 justify-between">
        <label class="block text-sm leading-5 ">Filter</label>
        <div class="flex rounded border ">
          <div class="inline-block relative flex-1">
            <select v-model="params.factor"
                    class="block appearance-none w-full bg-white px-4 py-2 pr-8 leading-tight focus:outline-none">
              <option value="After">After</option>
              <option value="On">On</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
              </svg>
            </div>
          </div>
          <div class="inline-block  relative flex-1">
            <input type="text" required v-model="params.factor_count"
                   class="appearance-none relative block w-full px-3 py-2 placeholder-gray-500 text-gray-900
                       focus:outline-none sm:text-sm sm:leading-5"
                   placeholder="Number of"/>
          </div>
          <div class="inline-block relative flex-1">
            <select v-model="params.factor_type"
                    class="block appearance-none w-full bg-white px-4 py-2 pr-8 leading-tight focus:outline-none">
              <option value="Session">Session(s)</option>
              <option value="Day">Day(s)</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6" v-if="$store.getters.can('change_splash_pages_presentation')">
        <button @click="saveSetting" class="rounded-sm px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white">
          Save
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import SplashPageService from '../../services/splashPage.service';
import AccessPointService from "../../services/access_points.service";
import VenueService from "../../services/venues.service";

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import Utils from "../../services/Utils";
import ApiService from "../../services/api.service";

export default {
  name: "DisplayOptions",
  comments: {},
  components: {DatePicker},
  props: {
    pageId: String
  },
  watch: {
    venues: function (newVenues) {
      const self = this;
      this.filters.aps = [];
      newVenues.forEach(function (venue) {
        self.getAps(venue.id)
      })
    }
  },
  data() {
    return {
      settings: [],
      filters: {
        aps: [],
        venues: [],
      },
      dateRange: {startDate: moment().startOf('day'), endDate: moment()},
      venues: [],
      access_points: [],
      params: {
        splash_page_id: this.pageId,
        access_points: [],
        start_date: moment.now(),
        end_date: null,
        factor: "After",
        factor_count: 1,
        factor_type: "Day"
      }

    }
  },
  mounted() {
    ApiService.get(process.env.VUE_APP_SERVER_URL + `/api/v1/splash_pages/display_settings/${this.pageId}`).then(response => {
      this.settings = response.data.settings;
      console.log(this.settings);
    })
    VenueService.getAll().then(response => {
          this.filters.venues = response.venues;
        }
    )
  },
  methods: {
    saveSetting() {
      const aps = [];
      this.access_points.forEach(function (ap) {
        aps.push(ap.id)
      })
      this.params.access_points = aps;
      SplashPageService.createDisplaySettings(this.params).then(response => {
        if (response.setting == null) {
          if (response.error != null && response.error.response != null && response.error.response.status === 422) {
            console.log(response.error.response.data);
            this.$root.$emit("alert_error", Utils.processError(response.error.response.data));
          } else
            this.$root.$emit("alert_error", [response.message])
        } else {
          this.$root.$emit("refresh_page", true)
          this.$root.$emit("alert_success", [response.message])
        }
      })
    },
    getAps(venueId) {
      AccessPointService.getAll("venue_id=" + venueId).then(response => {
            this.filters.aps = this.filters.aps.concat(response.access_points);
          }
      );

    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.mx-datepicker {
  width: 100% !important;
}
</style>